import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";

const F = ({ id, label, children }) => <div className="space-y-1.5"><Label htmlFor={id}>{label}</Label>{children}</div>;

export const blankClient = () => ({ name: "", phone: "", email: "", document: "", contact_person: "", address: "", notes: "", active: true, email_opt_out: false });

const Toggle = ({ id, label, checked, onChange }) => (
  <div className="flex items-center justify-between gap-3 rounded-lg border border-slate-700 bg-slate-950/50 px-3 py-2">
    <Label htmlFor={id} className="text-sm">{label}</Label>
    <Switch id={id} checked={checked} onCheckedChange={onChange} data-testid={`${id.replace(/_/g, "-")}-switch`} />
  </div>
);

export const ClientFields = ({ c, setC, withName = false }) => {
  const set = (k) => (e) => setC({ ...c, [k]: e.target.value });
  const input = (k, props) => <Input id={`cf_${k}`} value={c[k] || ""} onChange={set(k)} className="bg-slate-950" {...props} />;
  return (
    <div className="space-y-3">
      {withName && <F id="cf_name" label="Nome do cliente">{input("name", { required: true, placeholder: "Nome ou razão social", "data-testid": "client-name-input" })}</F>}
      <div className="grid gap-3 sm:grid-cols-2">
        <F id="cf_phone" label="Telefone / WhatsApp">{input("phone", { placeholder: "(00) 00000-0000", inputMode: "tel", "data-testid": "client-phone-input" })}</F>
        <F id="cf_contact_person" label="Nome do contato">{input("contact_person", { placeholder: "Com quem falar", "data-testid": "client-contact-person-input" })}</F>
        <F id="cf_email" label="E-mail">{input("email", { type: "email", placeholder: "cliente@email.com", "data-testid": "client-email-input" })}</F>
        <F id="cf_document" label="CPF ou CNPJ">{input("document", { inputMode: "numeric", placeholder: "000.000.000-00", "data-testid": "client-document-input" })}</F>
      </div>
      <F id="cf_address" label="Endereço">{input("address", { placeholder: "Rua, número, bairro, cidade", "data-testid": "client-address-input" })}</F>
      <F id="cf_notes" label="Observações">
        <Textarea id="cf_notes" rows={3} value={c.notes || ""} onChange={set("notes")} placeholder="Portão, horários, referências..." className="bg-slate-950" data-testid="client-notes-input" />
      </F>
      <div className="grid gap-2 sm:grid-cols-2">
        <Toggle id="client_active" label="Cliente ativo" checked={c.active !== false} onChange={(active) => setC({ ...c, active })} />
        <Toggle id="client_email_ok" label="Aceita avisos por e-mail" checked={!c.email_opt_out} onChange={(v) => setC({ ...c, email_opt_out: !v })} />
      </div>
    </div>
  );
};
